import React, { memo, useCallback, useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import { rem } from 'design-system';
import { InvestWalkthroughContext } from 'features/feed/components/walkthrough/context';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation, useMainStackRoute } from 'utils/types/navigationV6';
import SectionHeader from './SectionHeader';
import { StaticCollectionIds } from '../types';
import TrendingStock from './TrendingStock';
import useMostHeldStocks from '../hooks/useMostHeldStocks';
import { selectTradingAccount } from '../reducers/selectors';
const MostHeldStocksSection = ({ shouldFetch = true }) => {
    const { navigateDeprecated } = useMainStackNavigation();
    const isInInvestWalkthrough = useContext(InvestWalkthroughContext);
    const tradingAccount = useAppSelector(selectTradingAccount);
    const isAlpaca = tradingAccount?.isAlpaca === true;
    const mostHeldStocks = useMostHeldStocks({ shouldFetch });
    const route = useMainStackRoute();
    const onSeeMorePress = useCallback(() => {
        navigateDeprecated('InvestStaticCollectionDetails', {
            title: 'Most held',
            id: StaticCollectionIds.MOST_POPULAR,
            depositAndBuyFlowParams: route.params?.depositAndBuyFlowParams,
        });
    }, [route.params?.depositAndBuyFlowParams]);
    if (!mostHeldStocks?.length)
        return null;
    const title = isAlpaca ? 'Most held stocks' : 'Most popular';
    const subtitle = isAlpaca ? 'Last 30 days in Emma' : undefined;
    return (<>
      <SectionHeader title={title} subTitle={subtitle} onSeeMorePress={onSeeMorePress} style={isInInvestWalkthrough ? styles.walkthroughSectionStyles : null}/>
      <View style={isInInvestWalkthrough ? styles.walkthroughCard : null}>
        {mostHeldStocks.map((item, index) => (<TrendingStock assetId={item.assetId} key={item.assetId} isFirstItem={index === 0} isLastItem={index === mostHeldStocks.length - 1}/>))}
      </View>
    </>);
};
const styles = StyleSheet.create({
    walkthroughSectionStyles: {
        marginTop: rem(4),
        paddingHorizontal: rem(4),
    },
    walkthroughCard: {
        marginHorizontal: rem(4 - 16),
    },
});
export default memo(MostHeldStocksSection);
